import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

const ApexChart = ({ options = {}, series = [], type = 'line', height = '100%', width = '100%' }) => {
    const chartElement = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (!chartElement.current) {
            return undefined;
        }

        const chartOptions = {
            ...options,
            chart: {
                ...(options.chart || {}),
                type,
                height,
                width,
            },
            series,
        };

        chartInstance.current = new ApexCharts(chartElement.current, chartOptions);
        chartInstance.current.render();

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
                chartInstance.current = null;
            }
        };
    }, [height, options, series, type, width]);

    return <div ref={chartElement} style={{ width, height }} />;
};

export default ApexChart;
